import { render, staticRenderFns } from "./GitBranch.vue?vue&type=template&id=4be67545&scoped=true&"
import script from "./GitBranch.vue?vue&type=script&lang=js&"
export * from "./GitBranch.vue?vue&type=script&lang=js&"
import style0 from "./GitBranch.vue?vue&type=style&index=0&id=4be67545&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be67545",
  null
  
)

export default component.exports